import { render, staticRenderFns } from "./wie.vue?vue&type=template&id=2176c14f&"
import script from "./wie.vue?vue&type=script&lang=js&"
export * from "./wie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports